import { EServicesErrorCode } from 'core/model/enums/error-code.enum';
import { IAutoprospectionError, IMaintenanceError } from 'core/model/interfaces/error.interface';
import type { TSliceReducer } from 'core/store';
import { ILayoutState } from './types';

export const toogleCart: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  cart: action.payload,
});

export const toogleMenu: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  menu: action.payload,
});

export const setSearchQuery: TSliceReducer<ILayoutState, string> = (state, action) => ({
  ...state,
  search: action.payload,
});

export const setNotFound: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  isNotFound: action.payload,
});

export const toogleAddressModal: TSliceReducer<ILayoutState, boolean> = (state, action) => ({
  ...state,
  isAddressModalOpen: action.payload,
});

export const setLayoutError: TSliceReducer<
  ILayoutState,
  IMaintenanceError['error'] | IAutoprospectionError['error'] | null
> = (state, action) => {
  if (action.payload?.code === EServicesErrorCode.REDIRECT_TO_MAINTENANCE) {
    return {
      ...state,
      layoutError: { ...state.layoutError, maintenance: action.payload },
    };
  }
  if (action.payload?.code === EServicesErrorCode.LOGGED_IN_NO_PERMISSIONS) {
    return {
      ...state,
      layoutError: { ...state.layoutError, autoprospection: action.payload },
    };
  }
};

export const setNotifiedProducts: TSliceReducer<ILayoutState, string> = (state, action) => ({
  ...state,
  notifiedProducts: {
    ...state.notifiedProducts,
    [action.payload]: (state.notifiedProducts[action.payload] ?? 0) + 1,
  },
});

export const reducers = {
  toogleCart,
  toogleMenu,
  setSearchQuery,
  setNotFound,
  toogleAddressModal,
  setLayoutError,
  setNotifiedProducts,
};
